import React, { FC } from 'react';
import * as S from './styled';

export const Highlights: FC = props => {
	return (
		<S.Highlights>
			<S.Title>Highlights of your personalized plan:</S.Title>
			<S.List>
				<li>Weight loss tailored to your lifestyle</li>
				<li>Nutrition guidance and feedback</li>
				<li>Personal insights to stay on track</li>
				<li>Healthy habits that last</li>
			</S.List>
		</S.Highlights>
	);
};
